<div class="home-container">
  <div class="content">
    <div class="message" *ngIf="systemBannerMsg != null && systemBannerMsg.length >0">
      <span>{{systemBannerMsg}}</span>
    </div>

    <div class="message" *ngIf="servicingDeliveryMsgAvail != null && servicingDeliveryMsgAvail.length >0">
      <span>{{servicingDeliveryMsgAvail}}</span>
    </div>
    <img class="fm-logo" [src]="'../../../assets/images/ebmainpage.gif'" alt=""/>
  </div>
</div>

